import { render, staticRenderFns } from "./insurance_apply.vue?vue&type=template&id=01fba2de&scoped=true&"
import script from "./insurance_apply.vue?vue&type=script&lang=js&"
export * from "./insurance_apply.vue?vue&type=script&lang=js&"
import style0 from "./insurance_apply.vue?vue&type=style&index=0&id=01fba2de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fba2de",
  null
  
)

export default component.exports